export const ORGANISATION_DETAILS_ACTIVE_TAB_KEY = 'organisation-details-active-tab';

export type OrganisationDetailsTab = 'capture' | 'transactions';

export const navigateToEntityTab = (tab: OrganisationDetailsTab) => {
  sessionStorage.setItem(ORGANISATION_DETAILS_ACTIVE_TAB_KEY, tab);
};

export const navigateToEntityCaptureTab = () => navigateToEntityTab('capture');

export const navigateToEntityTransactionsTab = () =>
  navigateToEntityTab('transactions');
